import React from 'react'
import Styles from './footer.module.css'
function Footer() {
  return (
    <div className={Styles.footer}>
      <div style={{paddingLeft:"10px"}}>
       Club
      </div>
      <div style={{paddingRight:"10px"}}>
        Club © 2026
      </div>
    </div>
  )
}

export default Footer